import { setEstimationReady } from './actions';
import {
  fetchGetUserAnswersFromHistory,
  IGetUserAnswersFromHistoryResponse200 as IRes200,
  IGetUserAnswersFromHistoryResponse400 as IRes400,
} from '../../repositories/price-estimator/v2/get-user-answers-from-history';
import { TThunkAction } from '../../types/redux';

export function checkEstimationForUser(): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const {
      filters: { roomsCount, area, houseId },
    } = getState();

    try {
      const res = await fetchGetUserAnswersFromHistory<IRes200, IRes400>({
        httpApi,
        parameters: {
          roomsCount: roomsCount as number,
          area: area as number,
          houseId: houseId as number,
        },
      });

      if (res.statusCode === 200 && res.response.estimationId) {
        dispatch(
          setEstimationReady({
            estimationId: res.response.estimationId,
            offer: res.response.offer,
          }),
        );

        return true;
      }

      if (res.statusCode !== 200) {
        logger.warning('Bad request v2/get-user-answers-from-history', { roomsCount, area, houseId });
      }

      return false;
    } catch (e) {
      logger.error('Failed get v2/get-user-answers-from-history', e);

      return false;
    }
  };
}
